export default {
  'analysis.test': 'Gongzhuan No.{no} shop',
  'analysis.introduce': 'Introduce',
  'analysis.total-sales': 'Total Sales',
  'analysis.day-sales': 'Daily Sales',
  'analysis.visits': 'Visits',
  'analysis.visits-trend': 'Visits Trend',
  'analysis.visits-ranking': 'Visits Ranking',
  'analysis.day-visits': 'Daily Visits',
  'analysis.week': 'WoW Change',
  'analysis.day': 'DoD Change',
  'analysis.payments': 'Payments',
  'analysis.conversion-rate': 'Conversion Rate',
  'analysis.operational-effect': 'Operational Effect',
  'analysis.sales-trend': 'Stores Sales Trend',
  'analysis.sales-ranking': 'Sales Ranking',
  'analysis.all-year': 'All Year',
  'analysis.all-month': 'All Month',
  'analysis.all-week': 'All Week',
  'analysis.all-day': 'All day',
  'analysis.search-users': 'Search Users',
  'analysis.per-capita-search': 'Per Capita Search',
  'analysis.online-top-search': 'Online Top Search',
  'analysis.the-proportion-of-sales': 'The Proportion Of Sales',
  'analysis.dropdown-option-one': 'Operation one',
  'analysis.dropdown-option-two': 'Operation two',
  'analysis.channel.all': 'ALL',
  'analysis.channel.online': 'Online',
  'analysis.channel.stores': 'Stores',
  'analysis.sales': 'Sales',
  'analysis.traffic': 'Traffic',
  'analysis.table.rank': 'Rank',
  'analysis.table.search-keyword': 'Keyword',
  'analysis.table.users': 'Users',
  'analysis.table.weekly-range': 'Weekly Range'
}
